import { IStoreState, ThunkDispatch } from '../../modules';
import React, { Component } from 'react';
import { Theme, WithStyles, createStyles, withStyles } from '@material-ui/core/styles';

import Enrollment from '../common/enrollment';
import { bindActionCreators } from 'redux';
import classNames from 'classnames';
import { connect } from 'react-redux';

const styles = (theme: Theme) => createStyles({
  root: {
    margin: '0 auto',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    alignItems: 'stretch',
    maxWidth: '45rem',
  },
}
)

type State = {
}

class AuthenticationsPane extends Component<Props, State> {
  state = {
  }

  componentDidMount = () => {
    document.title = "Authentication"
  }

  render = () => {
    const { classes } = this.props;

    return (
      <div className={classNames(classes.root)}>
        <Enrollment />
      </div>
    )
  }
}

const mapStateToProps = ({ auth }: IStoreState) => ({
  auth,
})

const mapDispatchToProps = (dispatch: ThunkDispatch) =>
  bindActionCreators(
    {
    }, dispatch
  )

interface Props extends WithStyles<typeof styles>, ReturnType<typeof mapStateToProps>, ReturnType<typeof mapDispatchToProps> {
}

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(AuthenticationsPane));